import React, { useEffect, useContext, useState } from "react";
import {
  Routes,
  Route,
  // Link,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Home from "../components/screens/home/Home";
import Login from "../components/screens/auth/Login";
// import LoadingComp from "../components/screens/LoadingComp";
// import { StoreContext } from "../store/Provider";
import Error from "../components/screens/home/Error";
// import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
// import { Button } from "@material-ui/core";
import routeConstant from "./compoent/routeConstant";
import Schedule from "../components/screens/schedule/Schedule";
import ScheduleSearchResult from "../components/screens/schedule/searchResult/ScheduleSearchResult";
import Blogs from "../components/screens/blogs/Blogs";
import BlogsDetail from "../components/screens/blogs/BlogsDetail";
import UpdatePassword from "../components/screens/auth/UpdatePassword";
import ScheduleSignup from "../components/screens/schedule/ScheduleSignup";
import ScheduleForgotPass from "../components/screens/schedule/ScheduleForgotPass";
import ScheduleLogin from "../components/screens/schedule/ScheduleLogin";
// import Statements from "../components/screens/statement/Statements";
// import AnaDashboard from "../components/screens/dashboard/Dashboard";
// import Shipments from "../components/screens/shipments/Shipments";
import ProtectedRoutes from "./compoent/ProtectedRoutes";
import { StoreContext as OmsContext } from "../order_managment/store/index";

// //////////////////////////////   mtsoms    ///////////////////////////////////////
// import Chat from "../order_managment/screens/chat";
import DashboardOms from "../order_managment/screens/dashboard";
// import Help from "../order_managment/screens/help";
import Confirmation from "../order_managment/screens/order/component/orderCreation/Confirmation";
import DocUpload from "../order_managment/screens/order/component/orderCreation/DocUpload";
import OrderLine from "../order_managment/screens/order/component/orderCreation/OrderLine";
import OrderPlan from "../order_managment/screens/order/component/orderCreation/OrderPlan";
import OrderSpecific from "../order_managment/screens/order/component/orderCreation/OrderSpecific";
import ResetPassword from "../order_managment/screens/auth/component/resetPassword/ResetPassword";

import EditConfirmation from "../order_managment/screens/order/component/editOrder/EditConfirmation";
import EditDocUpload from "../order_managment/screens/order/component/editOrder/EditDocUpload";
import EditOrderLine from "../order_managment/screens/order/component/editOrder/EditOrderLine";
import EditOrderPlan from "../order_managment/screens/order/component/editOrder/EditOrderPlan";
import EditOrderSpecific from "../order_managment/screens/order/component/editOrder/EditOrderSpecific";

import OrderList from "../order_managment/screens/orderList";
import OrderReport from "../order_managment/screens/orderReport";
// import Settings from "../order_managment/screens/settings";
import SystemLog from "../order_managment/screens/systemLog";
// import routeConstantOMS from "../order_managment/routes/utils/routeConstant";
import { IsLogin, IsShowRMS } from "../../src/utils";
// import ProtectedRoutesOMS from "../order_managment/routes/compoent/ProtectedRoutes";
import ChangePassword from "../order_managment/screens/auth/component/changePassword/ChangePassword";
import Profile from "../order_managment/screens/Profile";
// import FullDetails from "../order_managment/screens/orderList/component/fullDetails/FullDetails";
import MilestoneComponent from "../order_managment/screens/orderList/component/fullDetails/MilestoneComponent";
import Details from "../order_managment/screens/details/Details";
// import { DashboardStore } from "../order_managment/screens/dashboard/store";
import MainLayout from "../components/common/Layout/MainLayout";
import Dashboard from "../components/screens/dashboard/Dashboard";
import StatementHome from "../components/screens/home/StatementHome";
// import UserList from "../components/screens/UserList/UserList";
import { StoreContext } from "../store/Provider";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import PlacedOrder from "../order_managment/screens/orderList/component/PlacedOrder";
import ApprovedOrder from "../order_managment/screens/orderList/component/ApprovedOrder";
import ArchiveOrder from "../order_managment/screens/orderList/component/ArchiveOrder";
import ShippedOrder from "../order_managment/screens/orderList/component/ShippedOrder";
import RejectedOrder from "../order_managment/screens/orderList/component/RejectedOrder";
import { OrderListStore } from "../order_managment/screens/orderList/store";
import ResetPassAdmin from "../components/screens/ResetPassAdmin/ResetPassAdmin";
import RestrictOutStanding from "./compoent/RestrictOutStanding";
import RestrictAdmin from "./compoent/RestrictAdmin";
import RestrictOrder from "./compoent/RestrictOrder";
import RestrictShipment from "./compoent/RestrictShipment";
import { LOCAL_STORAGE_KEY, baseURL } from "../config";
// import NewFeature from "../components/common/NewFeaure/NewFeature";
import { path } from "../order_managment/constants/apiPath";
// import { userRole } from "../utils";
import instance from "../order_managment/common/api/interceptor";
import { NotificationManager } from "react-notifications";
import axios from "axios";
import Loading from "../order_managment/screens/loading/Loading";
import CreateUser from "../components/screens/createUser/CreateUser";
import Notification from "../order_managment/screens/notification/Notification";
import EditNotification from "../order_managment/screens/notification/EditNotification";
import Insurence from "../components/screens/insurence/Insurence";
import Cost from "../components/screens/RMS/Cost";
import Sell from "../components/screens/RMS/Sell";
// import Quotes from "../components/screens/RMS";
import Quote from "../components/screens/RMS/Quote";
import QuoteList from "../components/screens/RMS/QuoteList.js";
import QuoteDetails from "../components/screens/RMS/QuoteDetails.js";
import NotToAdmin from "./compoent/NotToadmin";
import RMSLogin from "../components/screens/auth/RMSLogin";
import RMSSignup from "../components/screens/RMS/RMSSignup";
import LCL from "../components/screens/RMS/LCL";
import FCL from "../components/screens/RMS/FCL";
import LCL_Quote from "../components/screens/RMS/LCL_Quote";
import FCL_Quote from "../components/screens/RMS/FCL_Quote";
import FCL_QuoteDetails from "../components/screens/RMS/FCL_QuoteDetails";

import ShipmentReport from "../components/screens/shipments/ShipmentReport.jsx";
import ShipmentReportCo2 from "../components/screens/shipments/ShipmentReportCo2.js";

import RestrictCreateOrder from "./compoent/RestrictCreateOrder.js";
import RestrictOrderLog from "./compoent/RestrictOrderLog.js";
import RestrictOrderDashboard from "./compoent/RestrictOrderDasboard.js";
import RestrictOrderLst from "./compoent/ResctrictOrderList.js";
import RestrictShipmentDashboard from "./compoent/RestrictShipmentDashboard.js";
import RestrictShipmentAnalytics from "./compoent/RestrictShipmentAnalytics.js";
import RestrictScheduleSearch from "./compoent/RestrictScheduleSearch.js";
import CreateNew from "../components/screens/createNew/CreateNew.js";
import Permission from "../components/screens/permission/permission.js";


// import { IsLogin } from '../utils/index'
///////////////////////////   mtsoms    ///////////////////////////////////////

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Navigation = () => {
  const context = useContext(StoreContext);
  const [online, setOnline] = useState(window.navigator.onLine);
  const [openalert, setOpenalert] = useState(false);
  const location = useLocation();
  const navigator = useNavigate();
  const omscontext = useContext(OmsContext);
  const [isMount, setIsMount] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };



  useEffect(async () => {
    if (IsLogin()) {
      const userdata = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
      );
      if (userdata) {
        await getUserDataInfo(userdata.access_token);
      }
      if (location.pathname.includes(routeConstant.CREATE_ORDER_MAIN)) {
        navigator(routeConstant.CREATE_ORDER, { replace: true });
      }
      if (location.pathname === routeConstant.ORDER_LIST) {
        navigator(routeConstant.ORDER_LIST_PLACED, { replace: true });
      }
    } else {
      // navigator(routeConstant.LOGIN);
      setIsMount(true);
    }
    window.addEventListener("offline", () => setOnline(false));
    window.addEventListener("online", () => setOnline(true));
  }, []);

  useEffect(() => {
    !online && setOpenalert(true);
  }, [online]);

  // console.log(omscontext.orderUserAccess, "PermissionNav");

  const getUserDataInfo = async (token) => {
    let data = await JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
    );
    if (data?.show_orderMangement === "true") {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post(`${baseURL}${path.USER_DETAILS}`, null, { headers })
        .then(async (res) => {
          if (res.data.Is_Success) {
            context.setOmsUserData(res.data.data ?? {});
            getUsersAccess(res.data.data.UserRoles);
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
        })
        .catch((err) => {
          console.warn(err);
          if (err.response) {
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
          setIsMount(true);
        });
    }
    setIsMount(true);
  };

  const getUsersAccess = (roles) => {
    instance
      .post(`${path.USER_ACCESS}?roles=${roles}`)
      .then(async (res) => {
       
        if (res.Is_Success) {
          omscontext.setOrderUserAccess(res.data ?? {});
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        setIsMount(true);
      })
      .catch((err) => {
        console.warn(err);
        if (err.response) {
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        setIsMount(true);
      });
  };

  if (!isMount) return <Loading />;

  return (
    <React.Fragment>
      <Routes>
        <Route path="/" exact element={<Navigate to={"/mts"} replace />} />
        <Route
          path="/mts"
          exact
          element={<Navigate to={routeConstant.BLOGS} replace />}
        />
        <Route
          path="/"
          exact
          element={
            <OrderListStore>
              <MainLayout />
            </OrderListStore>
          }
        >
          <Route path={routeConstant.BLOGS} element={<Blogs />} />
          <Route path={routeConstant.INSURANCE} element={<Insurence />} />

          <Route path={routeConstant.BLOGS_DETAILS} element={<BlogsDetail />} />
          <Route
            path={routeConstant.STATEMENT}
            exact
            element={
              <ProtectedRoutes>
                <RestrictOutStanding>
                  <StatementHome />
                </RestrictOutStanding>
              </ProtectedRoutes>
            }
          />
          {IsLogin() && (
            <Route
              path={routeConstant.LOGIN}
              element={<Navigate to={routeConstant.BLOGS} />}
            />
          )}
          <Route path={routeConstant.LOGIN} element={<Login />} />
          <Route path={routeConstant.RMS_LOGIN} element={<RMSLogin />} />
          <Route
            path={routeConstant.RESET_PASSWORD_LINK}
            element={<ResetPassword />}
          />
          {IsShowRMS() && (
            <Route path={routeConstant.RMS_SIGNUP} element={<RMSSignup />} />
          )}

          <Route
            path={routeConstant.SCHEDULE}
            element={
              <ProtectedRoutes>
                <RestrictScheduleSearch>
                  <Schedule />
                </RestrictScheduleSearch>
              </ProtectedRoutes>
            }
          />
          {/* <Route
            path={routeConstant.UserList}
            element={
              <ProtectedRoutes>
                <RestrictAdmin>
                <UserList />
                </RestrictAdmin>
              </ProtectedRoutes>
            }
          /> */}
          <Route
            path={routeConstant.USERS}
            element={
              <ProtectedRoutes>
                <RestrictAdmin>
                  <ResetPassAdmin />
                </RestrictAdmin>
              </ProtectedRoutes>
            }
          />
          <Route
            path={routeConstant.UPDATE_PASSWORD}
            element={
              <ProtectedRoutes>
                <UpdatePassword />
              </ProtectedRoutes>
            }
          />
          <Route
            path={routeConstant.SEARCH_RESULT}
            element={
              <ProtectedRoutes>
                <ScheduleSearchResult />
              </ProtectedRoutes>
            }
          />
          <Route
            path={routeConstant.SCHEDULE_SIGNUP}
            element={<ScheduleSignup />}
          />
          <Route
            path={routeConstant.SCHEDULE_LOGIN}
            element={<ScheduleLogin />}
          />
          <Route
            path={routeConstant.SCHEDULE_FORGOT_PASSWORD}
            element={<ScheduleForgotPass />}
          />
          <Route
            path={routeConstant.SHIPMENT}
            element={
              <ProtectedRoutes>
                <RestrictShipmentDashboard>
                  <Home />
                </RestrictShipmentDashboard>
              </ProtectedRoutes>
            }
          />
          <Route
            path={routeConstant.SHIPMENT_REPORT}
            element={
              <ProtectedRoutes>
                <RestrictShipment>
                  <ShipmentReport />
                </RestrictShipment>
              </ProtectedRoutes>
            }
          />
           <Route
            path={routeConstant.SHIPMENTCO2_REPORT}
            element={
              <ProtectedRoutes>
                <RestrictShipment>
                  <ShipmentReportCo2 />
                </RestrictShipment>
              </ProtectedRoutes>
            }
          />
          <Route
            path={routeConstant.DASHBOARD}
            element={
              <ProtectedRoutes>
                <RestrictShipmentAnalytics>
                  <Dashboard />
                </RestrictShipmentAnalytics>
              </ProtectedRoutes>
            }
          />
          {/* new routes */}
          <Route
            exact
            path={routeConstant.ORDER_DASHBOARD}
            element={
              <ProtectedRoutes>
                <RestrictOrderDashboard>
                  {/* <DashboardStore> */}
                  <DashboardOms />
                  {/* </DashboardStore> */}
                </RestrictOrderDashboard>
              </ProtectedRoutes>
            }
          />

          {/* routes for tabs */}
          <Route
            exact
            path={routeConstant.ORDER_LIST}
            element={
              <ProtectedRoutes>
                <RestrictOrderLst>
                  <OrderList />
                </RestrictOrderLst>
              </ProtectedRoutes>
            }
          >
            <Route
              exact
              path={routeConstant.ORDER_LIST_PLACED}
              element={<PlacedOrder />}
            />
            <Route
              exact
              path={routeConstant.ORDER_LIST_APPROVED}
              element={<ApprovedOrder />}
            />
            <Route
              exact
              path={routeConstant.ORDER_LIST_LOADED}
              element={<ShippedOrder />}
            />
            <Route
              exact
              path={routeConstant.ORDER_LIST_REJECTED}
              element={<RejectedOrder />}
            />
            <Route
              exact
              path={routeConstant.ORDER_LIST_ARCHIVE}
              element={
                // <ProtectedRoutes>
                <ArchiveOrder />
                // </ProtectedRoutes>
              }
            />
          </Route>
          <Route
            exact
            path={routeConstant.CREATE_ORDER}
            element={
              <ProtectedRoutes>
                <RestrictCreateOrder>
                  <OrderSpecific />
                </RestrictCreateOrder>
              </ProtectedRoutes>
            }
          />

          <Route
            exact
            path={routeConstant.LINE_DETAIL}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <OrderLine />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.ORDER_PLAN}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <OrderPlan />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.CONFIRMATION}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <Confirmation />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.DOC_UPLOAD}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <DocUpload />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />

          <Route
            exact
            path={routeConstant.EDIT_CREATE_ORDER}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <EditOrderSpecific />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />

          <Route
            exact
            path={routeConstant.EDIT_LINE_DETAIL}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <EditOrderLine />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.EDIT_ORDER_PLAN}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <EditOrderPlan />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.EDIT_DOC_UPLOAD}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <EditDocUpload />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.EDIT_CONFIRMATION}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <EditConfirmation />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.ORDER_LIST_FULL}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <Details />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.DASH_ORDER_LIST_FULL}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <Details />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.ORDER_LIST_FULL_MILESTONE}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <MilestoneComponent />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.ORDER_LIST_FULL_LOG}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <SystemLog />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.DASH_ORDER_LIST_FULL_LOG}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <SystemLog />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.ORDER_LIST_FULL_MILESTONE_DASH}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <MilestoneComponent />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.SYSTEM_LOG}
            element={
              <ProtectedRoutes>
                <RestrictOrderLog>
                  <SystemLog />
                </RestrictOrderLog>
              </ProtectedRoutes>
            }
          />
          {/* <Route
            exact
            path={routeConstant.NOTIFICATION}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <Notification />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.NOTIFICATION_EDIT}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <EditNotification />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          /> */}
          <Route
            exact
            path={routeConstant.LIST_EDIT_CREATE_ORDER}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <EditOrderSpecific />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.LIST_EDIT_LINE_DETAIL}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <EditOrderLine />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.LIST_EDIT_ORDER_PLAN}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <EditOrderPlan />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.LIST_EDIT_CONFIRMATION}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <EditConfirmation />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.LIST_EDIT_DOC_UPLOAD}
            element={
              <ProtectedRoutes>
                <RestrictOrder>
                  <EditDocUpload />
                </RestrictOrder>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.PROFILE}
            element={
              <ProtectedRoutes>
                <Profile />
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.CREATE_USER}
            element={
              <ProtectedRoutes>
                <CreateUser />
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.CHANGEPASSWORD}
            element={
              <ProtectedRoutes>
                <ChangePassword />
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.REPORTS}
            element={
              <ProtectedRoutes>
                <OrderReport />
              </ProtectedRoutes>
            }
          />
          {/*-- RMS--- */}
          <Route
            exact
            path={routeConstant.COST}
            element={
              <ProtectedRoutes>
                <RestrictAdmin>
                  <Cost />
                </RestrictAdmin>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.SELL}
            element={
              <ProtectedRoutes>
                <RestrictAdmin>
                  <Sell />
                </RestrictAdmin>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.QUOTE}
            element={
              <ProtectedRoutes>
                <QuoteList />
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.LCL}
            element={
              <ProtectedRoutes>
                <LCL />
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.FCL}
            element={
              <ProtectedRoutes>
                <FCL />
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.CREATEQUOTE}
            element={
              <ProtectedRoutes>
                <NotToAdmin>
                  <Quote />
                </NotToAdmin>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.LCL_CREATE_QUOTE}
            element={
              <ProtectedRoutes>
                <NotToAdmin>
                  <LCL_Quote />
                </NotToAdmin>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.FCL_CREATE_QUOTE}
            element={
              <ProtectedRoutes>
                <NotToAdmin>
                  <FCL_Quote />
                </NotToAdmin>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.FCL_QUOTE_DETAILS}
            element={
              <ProtectedRoutes>
                <NotToAdmin>
                  <FCL_QuoteDetails />
                </NotToAdmin>
              </ProtectedRoutes>
            }
          />

          <Route
            exact
            path={routeConstant.QUOTEDETAILS}
            element={
              <ProtectedRoutes>
                <NotToAdmin>
                  <QuoteDetails />
                </NotToAdmin>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.CREATE_NEW}
            element={
              <ProtectedRoutes>
                <CreateNew/>
              </ProtectedRoutes>
            }
          />
          <Route
            exact
            path={routeConstant.PERMISSION}
            element={
              <ProtectedRoutes>
                <Permission/>
              </ProtectedRoutes>
            }
          />
        </Route>
        
        <Route path="/*" element={<Error />} />
      </Routes>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={omscontext.backDropOpen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default Navigation;
